"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _error_red = _interopRequireDefault(require("@wisetack/assets/img/error_red.svg"));

var _ErrorWithIconModule = _interopRequireDefault(require("./ErrorWithIcon.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ErrorWithIcon(_ref) {
  var children = _ref.children;
  if (!children) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _ErrorWithIconModule["default"].error
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _error_red["default"],
    alt: 'error',
    width: '36px',
    height: '30px'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ErrorWithIconModule["default"].message
  }, children));
}

var _default = ErrorWithIcon;
exports["default"] = _default;